import { Pipe, PipeTransform } from '@angular/core';
import { OdooMovimiento } from './odoo-maestros.models';

const ZONA = 'America/Caracas';
const fPartes = new Intl.DateTimeFormat('es-VE', { day: '2-digit', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true, timeZone: ZONA });

interface Partes { dia: string; mes: string; anio: string; hora: string; }

function partes(iso: string | null | undefined): Partes | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  const p: Record<string, string> = {};
  fPartes.formatToParts(d).forEach((x) => { p[x.type] = x.value; });
  const sufijo = (p['dayPeriod'] || '').replace(/\s/g, ' ');
  return {
    dia: p['day'], mes: (p['month'] || '').replace('.', ''), anio: p['year'],
    hora: `${p['hour']}:${p['minute']} ${sufijo}`.trim(),
  };
}

/** «19-oct · 9:12 a. m.» (hora de Venezuela). */
@Pipe({ name: 'odooFechaCorta' })
export class OdooFechaCortaPipe implements PipeTransform {
  transform(iso: string | null | undefined): string {
    const p = partes(iso);
    return p ? `${p.dia}-${p.mes} · ${p.hora}` : '—';
  }
}

/** «02-oct-2026». */
@Pipe({ name: 'odooDiaLargo' })
export class OdooDiaLargoPipe implements PipeTransform {
  transform(iso: string | null | undefined): string {
    const p = partes(iso);
    return p ? `${p.dia}-${p.mes}-${p.anio}` : '—';
  }
}

/** «10:05 a. m.». */
@Pipe({ name: 'odooHoraSola' })
export class OdooHoraSolaPipe implements PipeTransform {
  transform(iso: string | null | undefined): string {
    return partes(iso)?.hora || '—';
  }
}

/** RIF «J305123456» → «J-30512345-6»; lo que no calza se deja igual. */
export function rifLegible(rif: string | null | undefined): string {
  const t = (rif || '').trim();
  const m = t.match(/^([A-Z])(\d{9})$/);
  return m ? `${m[1]}-${m[2].slice(0, 8)}-${m[2].slice(8)}` : t || '—';
}

@Pipe({ name: 'odooRif' })
export class OdooRifPipe implements PipeTransform {
  transform(rif: string | null | undefined): string { return rifLegible(rif); }
}

const ORIGEN: Record<string, string> = { aprobacion: 'al aprobar', 'tiempo-real': 'automático', cron: 'automático', manual: 'a mano' };

/** Pura: «Se actualizó el dato · automático» a partir de un movimiento de la bitácora. */
export function frase(m: OdooMovimiento): string {
  const que = m.accion === 'alta'
    ? (m.ok ? 'Se anotó en Odoo' : 'No se pudo anotar en Odoo')
    : (m.ok ? 'Se actualizó en Odoo' : 'No se pudo actualizar en Odoo');
  const quien = m.origen ? ORIGEN[m.origen] || '' : '';
  return quien ? `${que} · ${quien}` : que;
}

@Pipe({ name: 'odooFrase' })
export class OdooFrasePipe implements PipeTransform {
  transform(m: OdooMovimiento): string { return frase(m); }
}

export function trackPorCodigo(_i: number, f: { source_id: string }): string { return f.source_id; }
export function trackPorId(_i: number, m: { _id: string }): string { return m._id; }
